export default __webpack_public_path__ + "static/media/instant.039e2acd.svg";